import api from './AxiosInstance';

export class PlanComptService {
    updatePlanCompta = async ( updatedPlanCompta) => {
        try {
         
    
          const response = await api.put(`/PlanCompta/Update`, updatedPlanCompta)
    
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la mise à jour de prestation :', error);
          throw error;
        }
      };
    getOnePlanCompta = async (compte) => {
        try {
          const response = await api.get(`/PlanCompta/getSoldeCompte/${compte}`, {
         
          });
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
          // Gérer l'erreur ici si nécessaire
          throw error; // Vous pouvez relancer l'erreur pour la gérer à un niveau supérieur si nécessaire
        }
      };
    
  getAllPlanCompta = async () => {
    try {
      const response = await api.get(`/PlanCompta/listAll`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; // Vous pouvez relancer l'erreur pour la gérer à un niveau supérieur si nécessaire
    }
  };
//
  getTypeCompta = async (type_compte) => {
    try {
      const response = await api.get(`/PlanCompta/list?type=${type_compte}&perim=IPM`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; // Vous pouvez relancer l'erreur pour la gérer à un niveau supérieur si nécessaire
    }
  };
  addCompte = async ( newPrestation) => {
    try {
    
  
      const response = await api.post(`/PlanCompta/add`, newPrestation )
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  deleteCompte = async ( prestationId) => {
    try {
    
      const response = await api.delete(`/Prestations/delete/${prestationId}`)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de prestation :', error);
      throw error;
    }
  };

 

}


